import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import Hero from './components/Hero';
import StatsMarquee from './components/StatsMarquee';
import Principles from './components/Principles';
import PillarShowcase from './components/PillarShowcase';
import PortfolioPreview from './components/PortfolioPreview';
import InsightsRow from './components/InsightsRow';
import CtaSection from './components/CtaSection';

export default function Home() {
  return (
    <div className="bg-[#050505] text-white">
      <Navbar transparent />
      <main>
        <Hero />
        <StatsMarquee />
        <Principles />
        <PillarShowcase />
        <PortfolioPreview />
        <InsightsRow />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}